<template>
    <div v-if="currentUser">
        <div class="row">
            <div class="col-md-6">
                <contact-card :user="currentUser.user_types.group_admin"
                               :business="currentUser.user_types.business" type="group_admin"></contact-card>
            </div>
            <div class="col-md-6">
                Total Groups: {{groupAdminGroups.length}}<br>
                <div v-if="groupAdminBook.length > 0">
                    Total Individual Plans: {{groupAdminBook.length}}<br>
                </div>
                <div v-if="pendingTerms.length > 0">
                    Pending Terms: {{pendingTerms.length}}
                    <b-badge to="/dashboard/producer/pending-terms">View</b-badge>
                    <br>
                </div>
                <div v-if="groupAdminPendingActions.length > 0">
                    Pending Actions: {{groupAdminPendingActions.length}}
                    <b-badge to="/dashboard/producer/pending-actions">View</b-badge>
                    <br>
                </div>
            </div>
        </div>
        <div class="section row clearfix topmargin">
            <div class="col-md-12">
                <div v-if="groupAdminLoadingGroup" class="ml-3">
                    <b-spinner small></b-spinner>&nbsp;Loading groups...
                </div>
                <group-list :items="groupAdminGroups" type="group-admin" v-if="groupAdminGroups.length > 0"></group-list>
                <div v-if="groupAdminGroups.length === 0 && !groupAdminLoadingBook">
                    <h2>Group Business</h2>
                    <p>You currently have no group business with TDA.</p>
                    <p>If you are part of an Agency you may need groups assigned to your account.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import ContactCard from '../../../components/Dashboard/ContactCard'
    import GroupList from '../../../components/Dashboard/GroupList'
    import MemberList from '../../../components/Dashboard/MemberList'

    export default {
        name: 'Home',
        components: {MemberList, GroupList, ContactCard},
        computed: {
            ...mapGetters(['currentUser', 'groupAdminGroups', 'groupAdminBook', 'groupAdminPendingActions', 'groupAdminLoadingBook', 'groupAdminLoadingGroup']),
            pendingTerms () {
                let tempTermed = localStorage.getItem('tempTermed')
                tempTermed = tempTermed ? tempTermed.split(',') : []
                return tempTermed
            }
        },
        methods: {
            ...mapActions(['getGroupAdminGroups', 'getGroupAdminBook', 'getGroupAdminPendingActions'])
        },
        mounted () {
            this.getGroupAdminGroups()
            this.getGroupAdminBook()
            this.getGroupAdminPendingActions()
        }
    }
</script>

<style scoped>

</style>
